import {
  type PimFlagV1,
  type PimProductV11,
  type PimProductV1Flags,
} from '@redteclab/api/clients/bully'

type PartialFlags = Record<string, Omit<PimFlagV1, 'active'> & { active: true }>

export const productAccessorGetActiveFlags = (
  product: PimProductV11,
): PartialFlags => {
  const { flags } = product

  if (!flags) {
    return {}
  }

  return Object.fromEntries(
    Object.entries<PimFlagV1 | undefined>(
      flags as Record<keyof PimProductV1Flags, PimFlagV1 | undefined>,
    ).filter(
      (
        entry,
      ): entry is [string, Omit<PimFlagV1, 'active'> & { active: true }] => {
        const [, flag] = entry

        return flag?.active === true
      },
    ),
  )
}
